import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left: Text */}
          <div className="flex-1">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100/70 rounded-full mb-5 tracking-wide border border-accent-200/50">
              About The Resource
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              What Is{' '}
              <span className="text-primary-600">Superbuy Spreadsheet</span>?
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              Superbuy Spreadsheet is a structured resource system that helps shoppers discover
              products faster by organizing product links, categories, prices, QC information and
              shopping references in one convenient place.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Instead of spending hours searching manually through countless listings, users can
              explore carefully organized collections, compare products side by side, and make
              better purchasing decisions with confidence.
            </p>
            <Link
              to="/what-is-superbuy-spreadsheet"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-primary-800 underline underline-offset-4 transition-colors cursor-pointer"
            >
              Read The Complete Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right: Stats + Image */}
          <div className="flex-1 relative">
            <div className="flex justify-end gap-8 mb-8">
              <div className="text-right">
                <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">14</div>
                <div className="text-xs text-foreground-500 mt-1">Product Categories</div>
              </div>
              <div className="text-right">
                <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">1000+</div>
                <div className="text-xs text-foreground-500 mt-1">Curated Finds</div>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20shopping%20workspace%20with%20open%20laptop%20and%20fashion%20magazine%20on%20light%20oak%20desk%2C%20scattered%20product%20tags%20and%20fabric%20swatches%2C%20warm%20afternoon%20sunlight%2C%20creative%20studio%20photography%20with%20lived-in%20aesthetic&width=700&height=500&seq=about-v2-img&orientation=landscape"
                alt="Organized Superbuy Spreadsheet resources"
                className="w-full rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}